export const GET_OVERVIEW = 'action/admin/panel/overview'
